export default __webpack_public_path__ + "images/8358b9a213ff98b9b0d385561ae09640-lendbot-texto.svg";